export const certificateTypeEnum = [
    {
        stateId: "ID_CARD",
        stateName: "身份证"
    },
    {
        stateId: "PASSPORT",
        stateName: "护照"
    },
    {
        stateId: "HK_MACAO_PASS",
        stateName: "港澳通行证"
    },
    {
        stateId: "HK_MACAO_RESIDENT_CARD",
        stateName: "港澳台居民居住证"
    },
    ,
    {
        stateId: "HOME_RETURN_PERMIT",
        stateName: "回乡证"
    },
    {
        stateId: "TAIWAN_COMPATRIOT_PERMIT",
        stateName: "台胞证"
    },
]
